import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { ArrowRight, Play } from "lucide-react";
import HeroLanding from "@/components/HeroLanding";
import FondoDeLaPortada from "@/components/FondoDeLaPortada";
import LaRuta from "@/components/LaRuta";
import PorDondeEmpiezo from "@/components/PorDondeEmpiezo";
import Competencias from "@/components/portada/Competencias";
import FilaBlanca from "@/components/portada/FilaBlanca";
import LoQueHay from "@/components/portada/LoQueHay";
import QuienTeAcompana from "@/components/portada/QuienTeAcompana";
import { REJILLA, TARJETA, TARJETA_SUAVE } from "@/lib/aparicion.mjs";
// EL VÍDEO Y SU MINIATURA SE IMPORTAN, NO SE ESCRIBEN COMO RUTA. Estaban en `public/` como
// `/manifiesto.mp4` y `/manifiesto-poster.jpg`, o sea con un nombre que no cambia nunca: al
// rehacer el vídeo, la URL seguía siendo la misma y **el navegador y la caché de Cloudflare
// seguían sirviendo la miniatura vieja**. En local se veía la nueva y en academialpha.com la
// de antes, que es de los fallos más difíciles de creerse: el fichero está bien.
//
// Importándolos, webpack les pone el hash de su contenido en el nombre, así que la URL cambia
// SOLA en cuanto cambian los bytes y no hay caché que valga. Es la diferencia entre acordarse
// de purgar y que no haga falta acordarse: lo mismo que hacen las portadas de los cursos desde
// siempre, que se importan de `src/portadas/`.
import videoManifiesto from "@/media/manifiesto.mp4";
import posterManifiesto from "@/media/manifiesto-poster.jpg";


/**
 * ManifestoPlayer — reproductor del vídeo de presentación (estilo YouTube).
 * Arranca en idle con póster; solo se reproduce al pulsar el botón central de
 * Play. Sin desplazamientos laterales: el botón vive en el centro exacto.
 */
function ManifestoPlayer() {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const start = () => {
    const v = videoRef.current;
    if (!v) return;
    v.currentTime = 0;
    v.muted = false;
    v.play();
    setPlaying(true);
  };

  return (
    <div
      className="rounded-caja relative w-full max-w-4xl mx-auto aspect-video border border-white/10 overflow-hidden bg-alpha-black shadow-2xl"
      data-testid="hero-video"
    >
      <video
        ref={videoRef}
        playsInline
        preload="metadata"
        poster={posterManifiesto}
        controls={playing}
        className="w-full h-full object-cover"
        onEnded={() => setPlaying(false)}
        data-testid="hero-video-el"
      >
        <source src={videoManifiesto} type="video/mp4" />
      </video>

      {!playing && (
        <button
          onClick={start}
          aria-label="Reproducir el manifiesto de Academia Alpha"
          data-testid="hero-video-play"
          className="absolute inset-0 flex flex-col items-center justify-center group"
        >
          <span className="absolute inset-0 bg-gradient-to-t from-alpha-black/70 via-alpha-black/10 to-alpha-black/30" />
          <span className="relative w-20 h-20 md:w-24 md:h-24 rounded-full bg-alpha-red/95 flex items-center justify-center shadow-[0_0_50px_rgba(209,0,0,0.5)] transition-transform duration-200 group-hover:scale-110 group-active:scale-95">
            <Play className="w-8 h-8 md:w-10 md:h-10 text-white translate-x-0.5" fill="currentColor" />
          </span>
          <span className="relative mt-6 font-mono-alpha text-[10px] uppercase tracking-widest text-white/80">
            Reproducir · 1:16 · con sonido
          </span>
        </button>
      )}
    </div>
  );
}
const stagger = { animate: { transition: { staggerChildren: 0.08 } } };
const fadeUp = {
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.2, 0.8, 0.2, 1] } },
};

export default function Landing() {
  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      data-testid="page-landing"
      /* `nubes-de-neon` son tres resplandores rojos muy difusos que viven en la ventana y
         se mueven despacio. Van en el `background-image` de esta misma etiqueta, encima
         del color que pinta `FondoDeLaPortada`: son dos propiedades distintas, no se
         pisan, y así no hay ninguna capa que pueda quedar tapada —que es como se
         perdieron las dos primeras versiones del fondo—. La clase está en `index.css`. */
      className="overflow-hidden nubes-de-neon"
    >
      {/* LA PRIMERA PANTALLA vive en su propio fichero: `components/HeroLanding.jsx`.
          Ahi esta escrito que se cayo de aqui -las cifras inventadas y la foto del fundador-
          y por que. */}
      {/* EL FONDO DE TODA LA PORTADA, y es uno solo. Cada sección dice de qué tono es con
          `data-tono` y esto lo mezcla según dónde estés mirando: ninguna pinta ya su fondo.
          El porqué, entero, en `components/FondoDeLaPortada.jsx`. */}
      <FondoDeLaPortada />

      <HeroLanding />

      {/* LA CINTA SE RETIRA el 19 de octubre de 2026. Era una banda con «Aprender es
          transformarse» pasando de lado a lado, y se va por dos motivos. El de forma: con el
          hero en claro, su negro abria un agujero entre la primera pantalla y lo que viene
          -se veia el corte antes que lo que ponia, que es justo lo que ya le paso cuando era
          una banda blanca entre dos negros-. Y el de fondo: no decia nada que no dijera el
          hero. Las clases `.cinta` siguen en `index.css` por si vuelve en otro sitio. */
      }

      {/* LAS CINCO COMPETENCIAS, segunda fila desde el 19 de octubre de 2026. Salen del hero,
          donde eran cinco pildoras de once pixeles debajo del subtitulo, y pasan a tarjetas con
          el color de cada una. La leccion de muestra ya no esta aqui: la monta el hero, que es
          lo que decidio Gabri al elegir que la mitad derecha de la primera pantalla la ocupe el
          producto y no un objeto. El porque, en los dos ficheros. */}
      {/* LA FILA 2, Y ES UNA. Gabri, 19 de octubre de 2026: *«competencias y ese esquema
          deberian ser la fila 2 de la plataforma, la que va despues de la principal»*. Las
          cinco tarjetas dicen QUE se desarrolla y el esquema COMO se estudia: separarlas en
          dos secciones con dos fondos era contar dos cosas donde hay una. Por eso el
          `<section>`, el tono y el ancho estan aqui y no dentro de cada pieza. */}
      <section className="pt-14 lg:pt-16 pb-12 lg:pb-16" data-tono="ceniza"
               data-testid="landing-fila-2">
        <div className="max-w-[1320px] mx-auto px-6 flex flex-col gap-10 lg:gap-12">
          <Competencias />
          <LaRuta />
        </div>
      </section>

      {/* LA SEGUNDA FILA, y el primer negro de la pagina. A la izquierda «para tu curso» -la
          pregunta que deja el hero: vale, hay 56 cursos, pero ¿hay algo de LO MIO?-, y a la
          derecha el repaso, que es la unica metodologia de esta portada que se puede
          comprobar: o te lo vuelve a preguntar al tercer dia o no.
          EL NEGRO VA A LA DERECHA, y en la fila siguiente ira a la izquierda: es la regla de
          balance que aprobo Gabri el 19 de octubre -uno por fila, de lado alterno- y que mide
          `lib/sistemaDeLaPortada.mjs`. */}
      <section className="py-10 lg:py-14" data-tono="nacar" data-testid="landing-fila-saber">
        {/* EL OLVIDO BAJA A LA FILA DE LOS MENTORES el 3 de noviembre de 2026, a la izquierda.
            La regla de balance no se rompe, se desplaza: sigue habiendo un negro por fila y
            sigue alternando de lado —antes a la derecha de esta, ahora a la izquierda de la
            siguiente—. Lo que cambia es que esta fila se queda sin él y la de los mentores
            deja de ser la de descanso. */}
        {/* A LA DERECHA, LOS MENTORES (3 de noviembre de 2026). Aquí estuvo el repaso hasta
            que salió de la portada, y antes de eso esta fila fue sólo el catálogo. Quien acaba
            de mirar si hay algo de lo suyo tiene al lado con quién lo estudiaría. */}
        <div className="max-w-[1320px] mx-auto px-6 grid gap-4 lg:gap-5 lg:grid-cols-12">
          {/* `h-full` en las dos: la rejilla estira la CELDA, no la tarjeta de dentro. Sin
              esto, cada una acaba donde acaba su contenido y la fila no cierra plana. Lo que
              manda la altura es la más alta de las dos, sin mínimos escritos a mano: el día
              que una encoja, encoge la fila. */}
          <div className="lg:col-span-5 h-full"><LoQueHay /></div>
          <div className="lg:col-span-7 h-full"><QuienTeAcompana /></div>
        </div>
      </section>

      {/* LA FILA BLANCA: los mentores encogidos, quien esta detras y el profesor. Vive en
          `components/portada/FilaBlanca.jsx`, y alli esta escrito que se cayo de aqui -los
          parrafos de cada mentor, que decian la materia- y por que. Es ademas la fila de
          descanso de la regla de balance: ni un bloque negro. */}
      <FilaBlanca />

      {/* Y LA PUERTA AL TEST, en su propio fichero desde el 7 de octubre: no describe la
          Academia, pide algo. El porqué —y lo que queda por decidir— están allí. */}
      <PorDondeEmpiezo />

      {/* EL CIERRE, Y ES LA BANDA NEGRA DE FILA ENTERA. La regla de balance que aprobó Gabri
          el 19 de octubre de 2026 dice que el negro a todo lo ancho va **solo al final**: en
          mitad de la página parte el recorrido en dos, y al final lo cierra. Por eso el vídeo
          baja aquí -*«el vídeo al final»*, 19 de octubre- y pasa de `hollin` a `tinta`, que es
          el escalón más hondo de la escalera: el único sitio donde se puede tocar fondo sin
          que haya que volver a subir.

          EL HUECO DE ARRIBA ES LA TRANSICIÓN. El fondo va de `nacar` a `tinta`, que es el
          salto más grande de la portada, y tiene que ocurrir donde no hay texto que leer. */}
      <section className="relative overflow-hidden pt-32 lg:pt-40" data-tono="tinta"
               data-testid="landing-cierre">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 flex flex-col items-center">
          <div className="text-center mb-12 max-w-3xl">
            <div className="font-mono-alpha text-[11px] uppercase tracking-widest text-alpha-red mb-4">
              Manifiesto en movimiento
            </div>
            <h2 className="font-serif-display text-white text-5xl lg:text-6xl leading-[0.95] tracking-tight text-balance">
              Cuando el pensamiento se vuelve <span className="italic text-alpha-red">experiencia.</span>
            </h2>
          </div>

          <ManifestoPlayer />
        </div>
      </section>

    </motion.main>
  );
}
